// extracted by mini-css-extract-plugin
export default {"container":"_o-z","heading":"ap-z","text":"bp-z","info":"cp-z","link":"dp-z","fullMaxWidth":"ep-z"};